import React from "react";

export default function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-16`}>
      {eyebrow && (
        <div className="font-cinzel text-xs tracking-[0.4em] text-[color:var(--jk-gold)] mb-4" data-testid="section-eyebrow">
          — {eyebrow}
        </div>
      )}
      <h2 className="font-cinzel font-bold text-3xl sm:text-4xl md:text-5xl leading-tight" data-testid="section-title">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-6 text-[color:var(--jk-muted)] text-base md:text-lg leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
